import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import { RECOMMEND_STORE_COPY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { reDirectPage, setDetailPageUrl } from '../../../../../lib/common';
import './RecommendStoreDetailNavbar.scss';

const RecommendStoreDetailNavbar = (props) => {
  const { recommendStoreId } = props;

  return (
    <FixedBottomNavBar className="recommend-store-detail-navbar">
      <div className="button-group">
        <Button
          color="primary"
          text="복사하기"
          onClick={() => reDirectPage({ path: setDetailPageUrl(RECOMMEND_STORE_COPY_URL_PATH, recommendStoreId) })}
        />
      </div>
    </FixedBottomNavBar>
  );
};

export default RecommendStoreDetailNavbar;
